import { render } from "./InfoWidget.vue?vue&type=template&id=7d0084aa"
const script = {}

import "./InfoWidget.vue?vue&type=style&index=0&id=7d0084aa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__